function escapeHtml(value) {
    return String(value ?? '')
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#039;')
}

export function replaceDescriptionPlaceholders(description, contact = {}) {
    const safeContact = contact ?? {}
    const replacements = {
        '{nome_do_contato}': safeContact.name,
        '{email_do_contato}': safeContact.email,
        '{nome_do_destinatario}': safeContact.name,
        '{email_do_destinatario}': safeContact.email,
        '{telefone_do_destinatario}': safeContact.cellphone || safeContact.phone,
    }

    return Object.entries(replacements).reduce((currentDescription, [placeholder, value]) => {
        return currentDescription.replaceAll(placeholder, escapeHtml(value))
    }, String(description ?? ''))
}
